import { render, staticRenderFns } from "./SelectedFacilities.vue?vue&type=template&id=3389bb3a&scoped=true&"
import script from "./SelectedFacilities.vue?vue&type=script&lang=js&"
export * from "./SelectedFacilities.vue?vue&type=script&lang=js&"
import style0 from "./SelectedFacilities.vue?vue&type=style&index=0&id=3389bb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389bb3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
